import type { PropsWithChildren } from 'react';

import styles from './TrafficSection.module.scss';

type Props = {
	title?: string | undefined;
};

export function TrafficSection({ children, title }: PropsWithChildren<Props>) {
	return (
		<section className={styles.wrapper}>
			{title && <h2 className={styles.title}>{title}</h2>}

			{children}
		</section>
	);
}
